import Select from 'antd/lib/select';
import * as React from 'react';
import withStyles from 'react-jss';
import { useReduxState } from 'src/hooks/useRedux';
import { KeyLabel, StylesProps } from 'src/Library/Types';
// data should not be fetched from inquiry masterdata
import withInquiryMasterData from 'src/components/pages/Enquiry/hoc/InitInquiryMaster';
import { useEffect, useState } from 'react';
import { fetchTaggableUsers } from 'src/api/comments';
import { FetchActivityResponseType, FetchShipmentActivityDto, TaggableUserType } from '../../SE.Types';
import Spin from 'antd/lib/spin';
import { fetchAllActivities } from 'src/api/shipmentExecution';
import Icon from 'antd/lib/icon';
import SEActivityTimeline from './SEActivityTimeline';
import Menu from 'antd/lib/menu';
import Dropdown from 'antd/lib/dropdown/dropdown';
import ExpandableSearchInput from '../../SECommon/ExpandableSearchInput';
import VisibilitySensor from 'react-visibility-sensor';

const styles = theme => ({
  parentDiv: {
    background: 'white',
    borderRadius: '0 4px 4px 0',
    padding: theme.spacing.ms,
    overflowY: 'auto',
    maxHeight: 500,
    paddingBottom: 100,
  },
  filtersParentDiv: {
    color: theme.colors.textSecondary,
    fontSize: theme.fontSize.small,
    display: 'flex',
    justifyContent: 'space-between',
    lineHeight: 2.5,
    paddingBottom: theme.spacing.ms,
    borderBottom: '1px solid #EDEDED',
  },
  activityParentDiv: {
    padding: `${theme.spacing.lg}px ${theme.spacing.lg}px 0px`,
    overflow: 'auto',
  },
  loaderDiv: {
    width: '100%',
    height: '150px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  filtersLeftSide: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  filterLabel: {
    marginRight: theme.spacing.sm,
    cursor: 'pointer',
  },
  filterSelectDiv: {
    width: 200,
    marginRight: theme.spacing.lg,
  },
  redText: {
    color: '#DF1D1D',
    cursor: 'pointer',
  },
  showMoreParentDiv: {
    marginLeft: '158px',
    color: theme.colors.primary,
    fontSize: theme.fontSize.body,
    cursor: 'pointer',
  },
  showMoreIcon: {
    color: theme.colors.primary,
    marginRight: '2px',
  },
  showMoreLoaderDiv: {
    marginLeft: '158px',
  },
  filterRightSide: {
    display: 'flex',
    alignItems: 'center',
    height: 32,
  },
});
export interface SEActivityProps extends StylesProps<ReturnType<typeof styles>> {
  shipmentId: string;
}
 
const SEActivity: React.FC<SEActivityProps> = ({ shipmentId, classes }) => {

  const [loadingMoreActivities, setLoadingMoreActivities] = useState(false);
  const [queryString, setQueryString] = useState<string | undefined>();
  const [isSearchExpanded, setIsSearchExpanded] = useState<boolean>(false);
  const [data, setData] = useState<FetchActivityResponseType>();
  const [isSearchingUser, setIsSearchingUser] = useState(false);
  const [eventFilterValue, setEventFilterValue] = useState<string[]>([]);
  const [loadingActivities, setLoadingActivities] = useState<boolean>(false);
  const [userFilterValue, setUserFilterValue] = useState<string[]>([]);
  const [userOptions, setUserOptions] = useState<TaggableUserType[]>([]);
  const [sortByFilterValue, setSortByFilterValue] = useState<string | 'updated_at'>('updated_at');
  let activityRequestBody: FetchShipmentActivityDto = {
    queryString: undefined,
    userList: [],
    typeEventList: [],
    descendingOrder: true,
    nextOrPrev: 'first',
    lastSortedColumnValue: '',
    currentPageNumber: 0,
  };
  
  useEffect(() => {
    setTaggableUserData();
  }, []);

  const getFilterParams = () => {
    const descendingOrder = sortByFilterValue === 'updated_at' ? true : false;
    const typeEventList = [...eventFilterValue];
    const userList = [...userFilterValue];

    return {
      ...activityRequestBody,
      descendingOrder,
      typeEventList,
      userList,
      queryString,
    };
  }

  useEffect(() => {
    setActivityData();
  }, [eventFilterValue, userFilterValue, sortByFilterValue, queryString]);


  const setActivityData = async (appendNewData = false) => {
    if (appendNewData) {
      setLoadingMoreActivities(true);
    } else {
      setLoadingActivities(true);
    }

    const filterParams = getFilterParams();
    activityRequestBody = {
      ...activityRequestBody,
      ...filterParams,
    };

    const fetchAllActivitiesParams = {
      id: shipmentId,
    };

    const response = await fetchAllActivities(fetchAllActivitiesParams, activityRequestBody);
    if (response.isSuccess) {
      if (appendNewData) {
        setData({
          ...response.data,
          data: (data?.data || []).concat(response.data?.data || []),
        });
      } else {
        setData(response.data);
      }
    }
  
    setLoadingMoreActivities(false);
    setLoadingActivities(false);
  };

  const setTaggableUserData = async () => {
    setIsSearchingUser(true);
    const response: any = await fetchTaggableUsers(
      {
        sourceObjectId: shipmentId,
        sourceObjectType: 'SHIPMENT',
        // queryString: userQueryString,
      },
      'execution'
    );
    if (response.isSuccess) {
      setUserOptions(response?.data as TaggableUserType[]);
    }
    setIsSearchingUser(true);
  };

  const eventOptions: Record<string, {type: string, event: string}[]> = useReduxState(
    ['inquiryReducer', 'masterData', 'activityFilters']
  ).value;

  const renderHeader = () => {
    const renderEventFilterDropdown = () => {
      const eventOptionsToShow: KeyLabel[] = eventOptions &&
        Object.keys(eventOptions).map((item) => ({
          key: item,
          label: item,
      }));
      return (
        <>
          <div className={classes.filterLabel}>{'Activity'}</div>
          <Select
            allowClear
            clearIcon={<Icon type="close-circle" theme="filled" style={{ color: "#DF1D1D" }} />}
            mode='multiple'
            maxTagTextLength={6}
            maxTagCount={1}
            className={classes.filterSelectDiv}
            value={eventFilterValue}
            placeholder={'All'}
            onChange={(e) => setEventFilterValue(e)}
          >
            {eventOptionsToShow.map(item => <Select.Option key={item.key}>{item.label}</Select.Option>)}
          </Select>
        </>
      );
    };
    
    const renderUserFilterDropdown = () => {
      const userOptionsToShow = userOptions &&
      userOptions.map((item) => ({
        key: item.id,
        label: `${item.name} (${item.organisationName})`,
        details: JSON.stringify(item),
      }));
      return (
        <>
          <div className={classes.filterLabel}>{'Users'}</div>
          <Select
            allowClear
            clearIcon={<Icon type="close-circle" theme="filled" style={{ color: "#DF1D1D" }} />}
            mode='multiple'
            maxTagCount={1}
            maxTagTextLength={6}
            className={classes.filterSelectDiv}
            value={userFilterValue}
            placeholder={'All'}
            optionFilterProp='label'
            onChange={(e) => setUserFilterValue(e)}
          >
            {(userOptionsToShow || []).map(item => <Select.Option key={item.key} label={item.label}>
              {item.label}
            </Select.Option>)}
          </Select>  
        </>
      );
    }

    const renderSortBy = () => {
      const sortByOptionsToShow = [
        {
          key: 'updated_at',
          label: 'Newest To Oldest',
        },
        {
          key: 'oldest',
          label: 'Oldest To Newest',
        },
      ];
  
      const sortByMenu = (
        <Menu onClick={(item) => {
          setSortByFilterValue(item.key)
        }} >
          {sortByOptionsToShow.map(item => (
            <Menu.Item key={item.key}>{item.label}</Menu.Item>
          ))}
        </Menu>
      );
      return (
        <Dropdown overlay={sortByMenu} placement="bottomLeft">
          <div className={classes.filterLabel} style={{ marginRight: 24 }}>
            Sort By
          </div>
        </Dropdown>
      );
    }

    const renderClearFilters = () => {
      if (!userFilterValue?.length &&
          !eventFilterValue?.length &&
          (sortByFilterValue === 'updated_at'))
      {
        return null;
      }
      return (
        <div
          className={`${classes.filterLabel} ${classes.redText}`}
          onClick={() => {
            setUserFilterValue([]);
            setEventFilterValue([]);
            setSortByFilterValue('updated_at');
          }}>
            Reset Filter
        </div>
      );
    }

    const renderSearchBar = () => {
      return (
        <ExpandableSearchInput
          value={queryString}
          onChange={(e) => setQueryString(e.target.value)}
        />
      );
    }

    return (
      <div className={classes.filtersParentDiv}>
        <div className={classes.filtersLeftSide}>
          {renderEventFilterDropdown()}
          {renderUserFilterDropdown()}
          {renderSortBy()}
          {renderClearFilters()}
        </div>
        <div className={classes.filterRightSide}>
          {renderSearchBar()}
        </div>
      </div>
    );
  };

  const renderActivityChart = () => {
    if (loadingActivities) {
      return (
        <div className={classes.loaderDiv}>
          <Spin size="large" />
        </div>
      );
    }

    return (
      <div className={classes.activityParentDiv}>
        <SEActivityTimeline data={data?.data} />
      </div>
    );
  };

  const renderShowMore = () => {
    const { isNextPresent } = data || {};

    if (!isNextPresent || loadingActivities || loadingMoreActivities) {
      return null;
    }

    const showMoreActivities = async () => {
      if (!data) return;
      const {
        lastItemIdNext: lastActivityId,
        lastSortedColumnValueNext: lastSortedColumnValue,
        currentPageNumber,
      } = data;
  
      activityRequestBody = {
        ...activityRequestBody,
        currentPageNumber,
        nextOrPrev: 'next',
        lastActivityId,
        lastSortedColumnValue: lastSortedColumnValue || '',
      };

      setActivityData(true);
    };
  
    return (
      <VisibilitySensor
        onChange={(isVisible) => {
          if (isVisible) {
            showMoreActivities();
          }
        }}
      >
        <div style={{ height: 20 }} />
      </VisibilitySensor>
    );
  };
  return <div className={classes.parentDiv}>
    {renderHeader()}
    {renderActivityChart()}
    {renderShowMore()}
  </div>;
}

export default withInquiryMasterData(withStyles(styles)(SEActivity));